
import { defineComponent, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
import ValidationService from '@/services/ValidationService';
import AppButton from '@/components/UI/AppButton.vue';
import AppInput from '@/components/UI/AppInput.vue';
import { CREATE_STEPS } from '@/types/enums';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
  },
  props: {
    dataLoading: { type: Boolean, default: false },
  },
  setup(props, context) {
    const inputData:Ref<string> = ref('');
    const router = useRouter();
    const schema = {
      groupName: 'required',
    };

    function nextStep() {
      context.emit('on-set-step', { value: inputData.value, step: CREATE_STEPS.SETTING });
    }

    return {
      schema,
      inputData,
      nextStep,
    };
  },
});
